export default __webpack_public_path__ + "feature1c894cb.png";